'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _containers = require('containers');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Customer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Customer, _Component);

  function Customer(props) {
    (0, _classCallCheck3.default)(this, Customer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Customer.__proto__ || (0, _getPrototypeOf2.default)(Customer)).call(this, props));

    _this.flipShowClosedTickets = function () {
      _this.setState(function (prevState) {
        return {
          showClosedTickets: !prevState.showClosedTickets
        };
      });
    };

    _this.state = {
      addedContactEmailDismissed: false,
      showClosedTickets: false
    };
    _this.handleAlertDismiss = _this.handleAlertDismiss.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Customer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var onUpdate = this.props.onUpdate;

      if (onUpdate) {
        onUpdate();
      }
    }
  }, {
    key: 'handleAlertDismiss',
    value: function handleAlertDismiss() {
      this.setState({ addedContactEmailDismissed: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Zendesk.scss'); // eslint-disable-line no-unused-vars, global-require
      var customerStyle = { marginBottom: '5px' };

      var _state = this.state,
          addedContactEmailDismissed = _state.addedContactEmailDismissed,
          showClosedTickets = _state.showClosedTickets;
      var _props = this.props,
          email = _props.email,
          plan = _props.plan,
          onPlan = _props.onPlan,
          trial = _props.trial,
          onTrial = _props.onTrial,
          onCouponTrial = _props.onCouponTrial,
          timezone = _props.timezone,
          openTickets = _props.openTickets,
          closedTickets = _props.closedTickets,
          zdAddedContactEmail = _props.zdAddedContactEmail,
          cameras = _props.cameras,
          isAol = _props.isAol,
          isBetaApp = _props.isBetaApp,
          doesNotExistInDjango = _props.doesNotExistInDjango,
          formUrls = _props.formUrls,
          notificationsEnabled = _props.notificationsEnabled,
          notificationsEnableAt = _props.notificationsEnableAt,
          notificationsEnableRelative = _props.notificationsEnableRelative,
          isCostco = _props.isCostco,
          children = _props.children,
          rest = (0, _objectWithoutProperties3.default)(_props, ['email', 'plan', 'onPlan', 'trial', 'onTrial', 'onCouponTrial', 'timezone', 'openTickets', 'closedTickets', 'zdAddedContactEmail', 'cameras', 'isAol', 'isBetaApp', 'doesNotExistInDjango', 'formUrls', 'notificationsEnabled', 'notificationsEnableAt', 'notificationsEnableRelative', 'isCostco', 'children']);

      // Replace America with US to make shorter.

      var timezoneNoAmerica = timezone.replace('America', 'US');

      var getFormButtons = function getFormButtons() {
        return _react2.default.createElement(
          _reactBootstrap.DropdownButton,
          {
            pullRight: true,
            bsSize: 'small',
            bsStyle: 'link',
            title: '',
            id: 'formButtons'
          },
          formUrls.map(function (logglyEntry) {
            return _react2.default.createElement(
              _reactBootstrap.MenuItem,
              {
                target: '_blank',
                href: logglyEntry.url,
                key: logglyEntry.url
              },
              logglyEntry.name
            );
          })
        );
      };

      var showTicketOverview = false;
      var planPartialString = doesNotExistInDjango ? 'Not registered Kuna User - ' + plan : plan + ' | ' + timezoneNoAmerica;

      var closedTicketsExpansionSymbol = showClosedTickets ? '▴' : '▾';

      // console.log(styles);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: customerStyle },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'strong',
                null,
                email,
                '   '
              ),
              !onPlan && !onTrial && !doesNotExistInDjango && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'danger' },
                'No Plan'
              ),
              onTrial && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'warning' },
                'On ',
                onCouponTrial && 'Coupon ',
                'Trial'
              ),
              isAol && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'primary' },
                'AOL?'
              ),
              doesNotExistInDjango && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'danger' },
                'Not a Kuna user!'
              ),
              !notificationsEnabled && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'info' },
                'Notifications',
                ' ',
                notificationsEnableRelative ? 'snoozed' : 'off'
              ),
              isBetaApp && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'success' },
                'Beta App'
              ),
              isCostco && _react2.default.createElement(
                _reactBootstrap.Label,
                { bsStyle: 'success' },
                'Costco'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              planPartialString,
              ' |',
              getFormButtons()
            )
          ),
          trial && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              onTrial ? 'Trial until' : 'Trial ended'
            ),
            ' :',
            ' ',
            _react2.default.createElement(_components.DateText, { time: trial, fullDate: true })
          ),
          !notificationsEnabled && notificationsEnableRelative && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Notifications snoozed '
            ),
            ' : back on',
            ' ',
            notificationsEnableRelative
          ),
          showTicketOverview && _react2.default.createElement(
            'div',
            null,
            openTickets.length > 0 && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Open Tickets'
              ),
              ' :',
              openTickets.length
            )
          ),
          openTickets && openTickets.map(function (ticket) {
            return _react2.default.createElement(_components.TicketInfo, (0, _extends3.default)({ ticket: ticket }, rest));
          }),
          closedTickets.length > 0 && _react2.default.createElement(
            _reactBootstrap.Button,
            {
              type: 'button',
              bsSize: 'xsmall',
              onClick: this.flipShowClosedTickets
            },
            _react2.default.createElement(
              'strong',
              null,
              'Closed Tickets'
            ),
            ' :',
            closedTickets.length,
            ' ',
            closedTicketsExpansionSymbol
          ),
          closedTickets && showClosedTickets && closedTickets.map(function (ticket) {
            return _react2.default.createElement(_components.TicketInfo, (0, _extends3.default)({ ticket: ticket }, rest));
          })
        ),
        cameras && cameras.map(function (camera) {
          return _react2.default.createElement(
            _containers.CameraWrapper,
            (0, _extends3.default)({ key: camera, sn: camera }, _this2.props),
            children
          );
        }),
        zdAddedContactEmail && !addedContactEmailDismissed && _react2.default.createElement(
          _reactBootstrap.Alert,
          {
            bsStyle: 'danger',
            bsSize: 'small',
            onDismiss: this.handleAlertDismiss
          },
          _react2.default.createElement(
            'strong',
            null,
            'Warning'
          ),
          ' Added',
          zdAddedContactEmail
        )
      );
    }
  }]);
  return Customer;
}(_react.Component), _class.propTypes = {
  email: _react.PropTypes.string,
  customerName: _react.PropTypes.string,
  plan: _react.PropTypes.string,
  onPlan: _react.PropTypes.bool,
  trial: _react.PropTypes.string,
  onTrial: _react.PropTypes.bool,
  onCouponTrial: _react.PropTypes.bool,
  timezone: _react.PropTypes.string,
  openTickets: _react.PropTypes.array,
  closedTickets: _react.PropTypes.array,
  zdTicketUrl: _react.PropTypes.object,
  zdTicketId: _react.PropTypes.object,
  zdAddedContactEmail: _react.PropTypes.object,
  cameras: _react.PropTypes.array,
  children: _react.PropTypes.object,
  onUpdate: _react.PropTypes.func,
  formUrls: _react.PropTypes.array,
  isAol: _react.PropTypes.bool,
  isBetaApp: _react.PropTypes.bool,
  doesNotExistInDjango: _react.PropTypes.bool,
  notificationsEnabled: _react.PropTypes.bool,
  notificationsEnableAt: _react.PropTypes.string,
  notificationsEnableRelative: _react.PropTypes.string,
  isCostco: _react.PropTypes.bool
}, _temp);
exports.default = Customer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Customer/Customer.js
 ** module id = 1380
 ** module chunks = 0
 **/